import { ViewProps } from './video.constants';
import { getRegionalisedQrCodeLink } from 'approot/shared/logic/get-regionalised-qr-code-link';
import { PrintStimulusAspectRatio } from '../print/print-stimulus';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import { getPrintImage } from '../shared/logic/get-print-image';

const VideoPrint = ({
  properties,
  stimulusResourceProperties,
  isPrintPreview,
  contentVersion,
}: ViewProps &
  CommonPrintProps & { contentVersion: string | null | undefined }) =>
  stimulusResourceProperties?.link ? (
    <PrintStimulusAspectRatio
      isPrintPreview={isPrintPreview}
      dimensions={properties.dimensionData}
      coverImage={
        getPrintImage(stimulusResourceProperties?.xlCoverImageUrls || null) ||
        stimulusResourceProperties?.coverImage?.original
      }
      link={getRegionalisedQrCodeLink(
        stimulusResourceProperties.link,
        contentVersion
      )}
    />
  ) : null;

export default VideoPrint;
